export abstract class BaseModel {
    id: number;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    enabled = true;
}

export class Profile extends BaseModel {
    supplierCode: string;
    parentCompany: string;
    ownershipTypeId: number;
    scoreCard: number;
    supplierDetails: SupplierMaster;
    primaryContact: string;
    profileAdmin: string;
    preferredStatusId: number;
    attachments: ProfileAttachment[] = [];
    ctpatData: SupplierCTPATScore;
    supplierSqeMapping: SupplierSQEMapping;
    tierLevel: string;

}

export class OwnershipType extends BaseModel {
    type: string;
}

class SupplierBase {
    id: number;
    name: string;
}

export class Supplier {
    supplierID: number;
    supplierCode: string;
    supplierName: string;
}

export class SupplierContact {
    supplierMasterContactId: number;
    firstName: string;
    lastName: string;
    userName: string;
    primaryEmail: string;
    position: string;
    initial: string;
    honorific: string;
    phone: string;
    fax: string;
    mobile: string;
    contactTypes: SupplierBase[];
    jobTitle: string;
    financeLead: boolean;
    date: Date;
    userId: number;
    supplierPortalAccountId: number;
    isApprovalRequired: boolean;
    isPrimaryAccount: boolean;
    approvalUserId: number;
    active: boolean;
    comment: string;
    supplierCodes: string[];
    types: string[];
}

class LocationTags {
    addressType: string;
    fullAddress: string;
    type: string;
}

class LocationProperties {
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}

export class Location {
    id: number;
    code: string;
    tags: LocationTags;
    properties: LocationProperties;
}

export class NavigationList {
    Name: string;
    Url: string;
    DisplayOrder: number;
    ImageUrl: string;
    ClassName: string;
    OpenInNewTab: boolean;
    NavigationItems: NavigationList[];
}

export class SupplierWarehouse extends BaseModel {
    profileId: number;
    locationName: string;
    address: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
}

export class Certification extends BaseModel {
    supplierCode: string;
    siteId: number;
    certificationTypeId: number;
    certificationType: string;
    certifiedDate: Date;
    expirationDate: Date | null;
    certifierName: string;
    attachments: CertificationAttachment[] = [];
    newFiles: File[] = [];
}

export class CertificationType extends BaseModel {
    type: string;
}

export class ProfileAttachment extends BaseModel {
    profileId: number;
    fileName: string;
    storageKey: string;
}

export class CertificationAttachment extends BaseModel {
    certificationId: number;
    fileName: string;
    storageKey: string;
}

export class PickupWarehouse {
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    locationName: string;
}

export class SupplierMaster {
    /**Gets or sets supplier name */
    supplierName: string;

    /**Gets or sets local supplier name */
    localSupplierName: string;

    /**Gets or sets short name */
    shortName: string;

    /**Gets or sets supplierCode */
    supplierCode: string;

    /**Gets or sets Account Group ID */
    accountGroupID: number | null;

    /**Gets or sets AccountGroup */
    accountGroup: string;

    /**Gets or sets InactiveDate */
    inactiveDate: Date | string | null;

    /**Gets or sets PrimarySupplierID */
    primarySupplierID: number | null;

    /**Gets or sets MeasurementSystem */
    measurementSystem: string;

    /**Gets or sets MeasurementSystem ID */
    measurementSystemID: number | null;

    /**Gets or sets SerializationCode */
    serializationCode: string;

    /**Gets or sets SupplierCategory */
    supplierCategory: SupplierBase[];

    /**Gets or sets SupplierSubCategory */
    supplierSubCategory: SupplierBase[];

    /**Gets or sets Comments */
    comments: string;

    /**Gets or sets DeActivatedByUser */
    deActivatedByUser: string;

    /**Gets or sets DeActivatedByUser */
    deActivatedByUserId: number | null;

    /**Gets or sets RiskFactorID */
    riskFactorID: number;

    /**Gets or sets a value indicating whether gets or sets EDIEnabled */
    eDIEnabled: boolean;

    /**Gets or sets a value indicating whether gets or sets ActiveFlag */
    activeFlag: boolean;

    /**Gets or sets dBA */
    dba: string;

    /**Gets or sets DiversityTypes */
    diversityTypes: string[];

    /**Gets or sets DiversityTypes */
    website: string;

    /**Gets or sets RiskFactor */
    riskFactor: string;

    /**Gets or sets AssessmentScore */
    assessmentScore: number | null;

    /**Gets or sets AssessedUserId */
    assessedUserName: string;

    /**Gets or sets AssessmentDate */
    assessmentDate: Date | string | null;

    /**Gets or sets SupplierOwner */
    ownerUserId: number;

    /**Gets or sets */
    ownerStartDate: Date | string | null;

    /**Gets or sets SupportOwner */
    supportOwnerUserId: number;

    /**Gets or sets PreferredBuyerID */
    preferredBuyerName: string;
}

export class SupplierCTPATScore {
    score: number;
    assessmentYear: number;
    supplierCode: string;
}

export class SupplierSQEMapping {
    /**Gets or sets supplierSQEMappingId */
    supplierSQEMappingId: number;

    /**Gets or sets supplierId */
    supplierId: number | null;

    /**Gets or sets */
    userId: number | null;

    /**Gets or sets */
    assessmentId: number | null;

    /**Gets or sets */
    assessmentStatus: string;

    /**Gets or sets */
    enabled: boolean | null;

    /**Gets or sets */
    assessmentScore: number | null;

    /**Gets or sets */
    priority: number | null;

    /**Gets or sets */
    tentativeDateOfAssessment: Date | string | null;

    /**Gets or sets */
    actualDateofAssessment: Date | string | null;

    /**Gets or sets */
    newSupplierId: number | null;

    /**Gets or sets */
    createdBy: number | null;

    /**Gets or sets */
    createdDate: Date | string | null;

    /**Gets or sets */
    modifiedBy: number | null;

    /**Gets or sets */
    modifiedDate: Date | string | null;

    /**Gets or sets */
    validUpToDate: Date | string | null;

    /**Gets or sets */
    supplierCode: string;

    /**Gets or sets gets gets or sets */
    assessedBy: string;

    /**Gets or sets a value indicating whether gets or sets gets gets or sets */
    isFromSupplierPortal: boolean;

    /**Gets or sets ConfidenceLevel */
    confidenceLevel: string;
}

export class RequestListItem {
    requestId: string;
    status: string;
    requestType: string;
    requestTypeDisplay: string;
    overallDueDate: Date;
    portalTaskId: number;
    progress: number;
    allowedActions: string[];
}